// Report a caught React error to the server so a frontend crash is not invisible.
//
// Replaces the `//logErrorToMyService(error, info);` placeholder that sat commented out in
// error-boundary.js while 107 boundaries silently discarded what they caught.

import axios from 'axios';

// A crash-render loop can fire boundaries continuously; the server rate-limits too, but the
// client should not generate the flood in the first place.
const MAX_REPORTS = 5;
const WINDOW_MS = 60 * 1000;
let sent = [];

export default function reportClientError(error, info) {
  try {
    const now = Date.now();
    sent = sent.filter((t) => now - t < WINDOW_MS);
    if (sent.length >= MAX_REPORTS) return;
    sent.push(now);

    const token = localStorage.getItem('token');
    if (!token) return; // the collector is authenticated; nothing to send as an anonymous user

    axios.post('/client-errors', {
      message: String((error && error.message) || error || 'unknown client error'),
      stack: error && error.stack ? String(error.stack) : undefined,
      componentStack: info && info.componentStack ? String(info.componentStack) : undefined,
      url: window.location && window.location.href,
    }, {headers: {'x-access-token': token}})
        .catch(() => {
          // Reporting a failure must never cause one. The boundary has already rendered
          // its fallback; there is nothing useful to do with an error from the reporter.
        });
  } catch (err) {
    // Same reasoning: never let the reporter throw into the boundary.
  }
}
